import React from 'react';
import {
    listeningDefinitions
} from './enums/listeningDefinitions.jsx';

export default function InstantSearchTips() {

    const {
        title,
        href
    } = listeningDefinitions['instant-search-tips'];

    return (
        <a
            className='tlw-self-start tlw-pl-3 tlw-text-sm'
            href={href}
            target='_blank'
            rel='noreferrer'
        >
            {title}
        </a>
    );
}
